import { StorageHandler } from "@/lib/storage";
import { uuid } from "@/lib/utils";

export interface PreviewState {
  isEnabled: boolean;
  sessionId?: string;
  guideId?: string;
  checklistId?: string;
}

export type PreviewStateStorage = ReturnType<typeof buildPreviewStateStorage>;

const key = "pyne-preview-state";

export const buildPreviewStateStorage = (storage: StorageHandler) => {
  const self = () => buildPreviewStateStorage(storage);

  return {
    get: () => {
      return storage.get(key, { isEnabled: false });
    },
    isPreview: () => {
      return self().get().isEnabled;
    },
    enableGuidePreview: (guideId: string) => {
      storage.set(key, { isEnabled: true, sessionId: uuid(), guideId, initialUrl: location.href });
    },
    enableChecklistPreview: (checklistId: string) => {
      storage.set(key, { isEnabled: true, sessionId: uuid(), checklistId, initialUrl: location.href });
    },
    getSessionId: () => {
      return self().get().sessionId;
    },
    getGuideId: () => {
      return self().get().guideId;
    },
    getChecklistId: () => {
      return self().get().checklistId;
    },
    clear: () => {
      storage.remove(key);
    },
  };
};
